export default {
  list: {
    loadError: 'スタディの読み込みに失敗しました。再試行してください。',
  },
  notFound: {
    shareRevoked: '所有者がこのリンクの共有を停止しました。',
    title: 'スタディが見つかりません',
    goToStudies: 'スタディ一覧へ',
    noAccess: 'このスタディは存在しないか、アクセス権がありません。',
    couldNotLoad: 'このスタディを読み込めませんでした。',
  },
  pageError: {
    title: 'このページで問題が発生しました',
    body: 'スタディはそのまま残っています。ページを再読み込みしてもう一度お試しください。繰り返し発生する場合はお知らせください。',
  },
  staleBundle: {
    title: '新しいバージョンが利用可能です',
    body: 'このタブは前回のデプロイ以降開かれたままで、移動されたアセットを読み込もうとしています。ページを再読み込みして新しいビルドを取得してください。スタディはそのまま残っています。',
    reload: '再読み込み',
  },
  results: {
    notReadyTitle: '結果はまだ準備できていません',
    notReadyMessage:
      'シミュレーションが完了するか、診断データを保存して停止すると結果を表示できます。',
    simulationsRunning:
      '一部のシミュレーションはまだ実行中です。進捗を確認するには「シミュレーション」に戻ってください。',
    backToSimulate: 'シミュレーションを表示',
  },
  diagnose: {
    preprocessingMessage: '診断はメッシュ工程の一部になりました。',
    movedTitle: '診断はメッシュに移動しました',
    draftMessage:
      'スタディを実行する前に、メッシュ工程でメッシュ設定を構成してください。',
    sharedMessage:
      '診断とメッシュ生成はメッシュ工程を共有するようになりました。',
  },
  status: {
    unknownTitle: '不明なステータス',
    unknownMessage: 'スタディが認識できない状態です（{{state}}）。',
  },
  simulate: {
    notYetTitle: 'まだシミュレーションしていません',
    notYetMessage: 'メッシュ工程が完了するとシミュレーションが開始します。',
    completeTitle: 'シミュレーションが完了しました',
    completeMessage: 'このスタディはシミュレーション工程を過ぎています。',
  },
} as const;
